module.exports = __webpack_public_path__ + "media/Video 7.2b292808.mp4";